<div class="text-center" *ngIf="histories_loading">
  <i class="fas fa-spinner fa-pulse fa-3x"></i>
</div>
<div *ngIf="!histories_loading">
  <h4 *ngIf="!parent_id">Search Histories</h4>
  <hr class="mt-1" *ngIf="!parent_id" />
  <form class="form-inline" *ngIf="!parent_id" novalidate>
    <label class="sr-only">Select Amount</label>
    <select class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Select Amount" name="amount" [(ngModel)]="search_params.per_page">
      <option *ngFor="let amount of search_options.amounts" [value]="amount.value">
        {{ amount.label }}
      </option>
    </select>
    <label class="sr-only">Select Type</label>
    <select class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Select Type" name="matter_history_type_id" [(ngModel)]="search_params.matter_history_type_id">
      <option *ngFor="let matter_history_type of search_options.matter_history_types" [value]="matter_history_type.value">
        {{ matter_history_type.label }}
      </option>
    </select>
    <label class="sr-only">Search For Author?</label>
    <select class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Search For Author?" name="created_by" [(ngModel)]="search_params.created_by">
      <option *ngFor="let author of search_options.authors" [value]="author.value">
        {{ author.label }}
      </option>
    </select>
    <label class="sr-only">Search Text For?</label>
    <input type="text" class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Search Text For?" name="search_text_for" [(ngModel)]="search_params.message" />
    <label class="sr-only">Search for Tag?</label>
    <input type="text" class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Search for Tag?" name="search_for_tag" [(ngModel)]="search_params.tags" />
    <input type="text" class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Search Begin Date" [appDatepicker]="" (dateSelected)="search_params.date_from = $event" />
    <input type="text" class="form-control form-control-sm mb-2 mr-sm-2 mb-sm-0 mt-1" placeholder="Search End Date" [appDatepicker]="" (dateSelected)="search_params.date_to = $event" />
    <button type="submit" style="cursor: pointer" class="btn btn-secondary mb-2 mr-sm-2 mb-sm-0 mt-1 btn-sm" (click)="loadHistories()" [disabled]="searchFormSubmitting">
      {{ searchFormSubmitting ? 'Submitting' : 'Filter Histories' }}<span *ngIf="searchFormSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
    </button>
    <div style="display: block !important; width: 100% !important"></div>
    <a href="javacript: void(0)" *ngIf="matterHistories.length > 0" (click)="expandHistories(true); $event.preventDefault()">Expand All</a>
    &nbsp;{{ matterHistories.length > 0 ? '|' : '' }}&nbsp;
    <a href="javacript: void(0)" *ngIf="matterHistories.length > 0" (click)="collapseHistories(); $event.preventDefault()">Collapse All</a>
  </form>
  <!--<div class='text-center pagination-small-margin pagination-center'>
		<pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="search_params.per_page" [maxSize]='3'
				previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
	</div>-->
  <div class="text-center pt-1">
    <app-pagination-count
      [count]="count"
      singularName="History"
      pluralName="Histories"
    ></app-pagination-count>
  </div>
  <div [id]="'matter-history-' + matterHistory.id" [class]="'card my-1 ' + (matterHistory.expanded ? 'border-primary' : '') + (matterHistory.selectedFromLink ? ' selected-history-link' : '')" [ngStyle]="{ 'font-size': '95%', 'border-left-style': matterHistory.depth % 2 != 0 ? 'dashed' : 'solid' }" *ngFor="let matterHistory of matterHistories">
    <div [class]="'card-header ' + (matterHistory.expanded ? 'bg-primary text-white' : '')">
      <div class="d-inline-block">
        <a href="javascript: void(0)" style="text-decoration: none !important" (click)="toggleHistory(matterHistory); $event.preventDefault()">
          <i [class]="'fa fa-' + (matterHistory.expanded ? 'minus' : 'plus') + '-circle ' + (matterHistory.expanded ? 'text-white' : '')"></i>
        </a>
        <br />
        <span style="font-size: 75%" *ngIf="matterHistory.depth && matterHistory.depth > 3">Level: {{ matterHistory.depth }}</span>
      </div>
      <span *ngIf="authService.isDevelopmentEnv">{{ matterHistory.id }}</span>
      <b>{{ matterHistory.created_at }}</b>
      <span [class]="'text-' + (matterHistory.expanded ? 'warning' : 'warning')" [title]="'Reminder set for ' + (matterHistory.reminder_date || matterHistory.reminder_start_date)" *ngIf="matterHistory.reminder_date || matterHistory.reminder_start_date"><i class="fas fa-bell"></i></span>
      {{ matterHistory.matter_history_type_name }}<span [innerHTML]="matterHistory.titleHTML | safeHtml"></span>
      <span *ngIf="matterHistory.historyInfo?.source === 'client_portal'" class="badge badge-info ml-1" title="Uploaded by {{ matterHistory.historyInfo?.contact_name || 'client' }} via client portal">Client Upload</span>
      <button type="button" [class]="'btn btn-' + (matterHistory.expanded ? 'light' : 'secondary') + ' btn-sm float-right'" (click)="replyToHistory(matterHistory)">Reply</button>
      <app-badge *ngIf="matterHistory.reply_count > 0" badgeType="primary" [pillBadge]="true" classes="m-2 float-right">
        <span *ngIf="matterHistory.second_descendants_count > 0"> {{ matterHistory.reply_count }} / {{ matterHistory.descendants_count }} replies </span>
        <span *ngIf="matterHistory.second_descendants_count < 1">
          {{ matterHistory.replyCountStr }}
        </span>
      </app-badge>
      <span class="float-right" *ngFor="let header_link of matterHistory.header_links">
        <a *ngIf="header_link.link_type == 'document'" [ngClass]="{ 'text-danger': !matterHistory.expanded, 'text-white': matterHistory.expanded }" [href]="'/documents/' + header_link.link_id + '/download?disposition=attachment'"><i class="fas fa-file-pdf"></i></a>
        <span *ngIf="header_link.link_type == 'outgoing_job'">
          <a [ngClass]="{ 'text-white': matterHistory.expanded }" [href]="'/outgoing_jobs/' + header_link.link_id" target="_blank">Job #{{ header_link.link_id }}</a>
          <span *ngIf="header_link.auto_outgoing_rule_id">
            &nbsp;-&nbsp;
            <a [ngClass]="{ 'text-white': matterHistory.expanded }" target="_blank" [href]="'/auto_outgoing_rules/' + header_link.auto_outgoing_rule_id + '/edit'">Auto Rule {{ header_link.link_id }}</a>
          </span>
        </span>
        <a [ngClass]="{ 'text-white': matterHistory.expanded }" target="_blank" *ngIf="header_link.link_type != 'document' && header_link.link_type != 'outgoing_job' && header_link.link_url" [href]="header_link.link_url">{{ header_link.titleized }}</a>
      </span>
    </div>
    <div class="card-body" *ngIf="matterHistory.expanded">
      <div *ngIf="!matterHistory.historyInfo && !matterHistory.historyError" class="text-center my-5">
        <i class="fas fa-spinner fa-pulse fa-3x"></i>
      </div>
      <div *ngIf="matterHistory.historyError" class="alert alert-warning my-3">
        {{ matterHistory.historyError }}
      </div>
      <div *ngIf="matterHistory.historyInfo">
        <div class="float-right">
          <button type="button" *ngIf="(currentUserId == matterHistory.created_by || currentUserId == matterHistory.updated_by) && !matterHistory.editing" class="btn btn-outline-secondary btn-sm" (click)="editHistory(matterHistory)">Edit</button>
          <button type="button" *ngIf="matterHistory.reply_count > 0" class="btn btn-outline-secondary btn-sm" (click)="expandChildren(matterHistory)">Expand Children</button>
          <button type="button" *ngIf="matterHistory.reply_count > 0" class="btn btn-outline-secondary btn-sm" (click)="collapseChildren(matterHistory)">Collapse Children</button>
          <button type="button" *ngIf="matterHistory.reply_count > 0" class="btn btn-outline-secondary btn-sm" (click)="expandAllLevels(matterHistory)">Expand All Levels</button>
        </div>
        <app-matter-history-form *ngIf="matterHistory.editing" [matter_id]="this.matter_id" [matterHistoryId]="matterHistory.id" [parent_id]="this.parent_id" (formResult)="historyFormResult(matterHistory, $event)"></app-matter-history-form>
        <table class="table table-sm table-border-none matter-history-detail-table" style="font-size: 90%" *ngIf="!matterHistory.editing">
          <tbody>
            <tr *ngIf="matterHistory.historyInfo.title && matterHistory.historyInfo.title.length > 0">
              <th scope="row">Title:</th>
              <td>{{ matterHistory.historyInfo.title }}</td>
            </tr>
            <tr *ngIf="matterHistory.historyInfo.created_by_user && matterHistory.historyInfo.created_by_user.length > 0">
              <th scope="row">Author:</th>
              <td>{{ matterHistory.historyInfo.created_by_user }}</td>
            </tr>
            <tr *ngIf="matterHistory.historyInfo.all_tags_list && matterHistory.historyInfo.all_tags_list.length > 0">
              <th scope="row">Tags:</th>
              <td>{{ matterHistory.historyInfo.all_tags_list }}</td>
            </tr>
            <tr *ngIf="(matterHistory.historyInfo.emails && matterHistory.historyInfo.emails.length > 0) || matterHistory.notify_accounting">
              <th scope="row">Notified:</th>
              <td>{{ matterHistory.notify_accounting ? 'Accounting' : '' }} {{ matterHistory.historyInfo.emails }}</td>
            </tr>
            <tr *ngIf="matterHistory.historyInfo.reminder && matterHistory.historyInfo.reminder.length > 0">
              <th scope="row">Reminder:</th>
              <td class="text-danger">{{ matterHistory.historyInfo.reminder }}</td>
            </tr>
            <tr *ngIf="matterHistory.historyInfo.updated_at_time && matterHistory.historyInfo.updated_at_time.length > 0">
              <th scope="row">Updated:</th>
              <td>{{ matterHistory.historyInfo.updated_at_time }}</td>
            </tr>
            <tr *ngIf="matterHistory.historyInfo.created_at_time && matterHistory.historyInfo.created_at_time.length > 0">
              <th scope="row">Created:</th>
              <td>{{ matterHistory.historyInfo.created_at_time }}</td>
            </tr>
            <tr>
              <th scope="row">Message:</th>
              <td [style]="matterHistory.historyInfo.messageStyle">
                <!-- On  -->
                {{ matterHistory.historyInfo.wrote }} <span [innerHTML]="matterHistory.historyInfo.message | safeHtml"></span>
              </td>
            </tr>
          </tbody>
	        </table>
	        <details class="matter-history-thread-view" *ngIf="!matterHistory.editing && matterHistory.historyInfo.thread_conversation && (matterHistory.historyInfo.thread_conversation.count > 1 || matterHistory.historyInfo.thread_conversation.latest_email_text)">
	          <summary>
	            Full conversation
	            <span *ngIf="matterHistory.historyInfo.thread_conversation.count > 1">({{ matterHistory.historyInfo.thread_conversation.count }} items)</span>
	          </summary>
	          <div class="matter-history-thread-panel">
	            <div class="matter-history-thread-latest" *ngIf="matterHistory.historyInfo.thread_conversation.latest_email_text">
	              <div class="matter-history-thread-heading">
	                Latest full email text
	                <a
	                  *ngIf="matterHistory.historyInfo.thread_conversation.latest_email_document"
	                  target="_blank"
	                  [href]="'/documents/' + matterHistory.historyInfo.thread_conversation.latest_email_document.id + '/download?disposition=inline'"
	                >
	                  open text file
	                </a>
	              </div>
	              <pre>{{ matterHistory.historyInfo.thread_conversation.latest_email_text }}</pre>
	            </div>
	            <div class="matter-history-thread-entry" *ngFor="let threadEntry of matterHistory.historyInfo.thread_conversation.entries">
	              <div class="matter-history-thread-meta">
	                <a [href]="'/matters/' + matter_id + '?history_id=' + threadEntry.id">#{{ threadEntry.id }}</a>
	                <span>{{ threadEntry.created_at_time }}</span>
	                <span *ngIf="threadEntry.created_by_user">{{ threadEntry.created_by_user }}</span>
	                <a
	                  *ngIf="threadEntry.email_document"
	                  target="_blank"
	                  [href]="'/documents/' + threadEntry.email_document.id + '/download?disposition=inline'"
	                >
	                  email text
	                </a>
	              </div>
	              <div class="matter-history-thread-message" [innerHTML]="threadEntry.message | safeHtml"></div>
	            </div>
	          </div>
	        </details>
	        <div class="matter-history-body-links" *ngFor="let body_link of matterHistory.historyInfo.body_links">
          <a *ngIf="body_link.link_type == 'document' && body_link.id" [href]="'/documents/' + body_link.id + '/download?disposition=attachment'"><i [class]="'fa fa-' + (body_link.file_type || 'file')"></i>&nbsp;{{ body_link.name }}</a>
          <span *ngIf="body_link.link_type == 'document' && body_link.source === 'client_portal'" class="badge badge-info ml-1" title="This document was uploaded by the client via the client portal">Client Upload</span>
          <div *ngIf="body_link.link_type == 'outgoing_job'">
            <a target="_blank" [href]="'/outgoing_jobs/' + body_link.link_id">Outgoing Job #{{ body_link.link_id }}</a>
            <br />
            <a *ngIf="body_link.auto_outgoing_rule_id" target="_blank" [href]="'/auto_outgoing_rules/' + body_link.auto_outgoing_rule_id + '/edit'">Auto Rule {{ body_link.auto_outgoing_rule_id }}</a>
            <h5 *ngIf="body_link.outgoing_documents && body_link.outgoing_documents.length > 0">Documents</h5>
            <table *ngIf="body_link.outgoing_documents && body_link.outgoing_documents.length > 0" class="table table-responsive table-striped">
              <thead>
                <th>Document</th>
                <th>Pages</th>
                <th>Copies</th>
                <th>Method</th>
                <th>Destination</th>
              </thead>
              <tbody>
                <tr *ngFor="let outgoingDocument of body_link.outgoing_documents">
                  <td>
                    <a target="_blank" [href]="'/documents/' + outgoingDocument.document_id + '/download'"><i class="fas fa-pdf-o"></i></a>
                  </td>
                  <td>{{ outgoingDocument.pages || 'all' }}</td>
                  <td>{{ outgoingDocument.copies }}</td>
                  <td>{{ outgoingDocument.way }}</td>
                  <td>
                    <a target="_blank" *ngIf="outgoingDocument.way == 'share'" [href]="'mailto:' + outgoingDocument.destination">{{ outgoingDocument.share_contact_name }}</a>
                    <span *ngIf="outgoingDocument.way != 'share'">{{ outgoingDocument.destination }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <h5 *ngIf="body_link.outgoing_envelopes && body_link.outgoing_envelopes.length > 0">Envelopes</h5>
            <table *ngIf="body_link.outgoing_envelopes && body_link.outgoing_envelopes.length > 0" class="table table-responsive table-striped">
              <thead>
                <th>Contact</th>
                <th>Copies</th>
                <th>Destination</th>
              </thead>
              <tbody>
                <tr *ngFor="let outgoingEnvelope of body_link.outgoing_envelopes">
                  <td [innerHTML]="outgoingEnvelope.full_address | safeHtml"></td>
                  <td>{{ outgoingEnvelope.copies }}</td>
                  <td>
                    <a target="_blank" [href]="'/outgoing_jobs/' + body_link.link_id + '/outgoing_envelopes/' + outgoingEnvelope.id + '.pdf'">{{ outgoingEnvelope.destination }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <h5 *ngIf="body_link.outgoing_checks && body_link.outgoing_checks.length > 0">Checks</h5>
            <table *ngIf="body_link.outgoing_checks && body_link.outgoing_checks.length > 0" class="table table-responsive table-striped">
              <thead>
                <th>Check #</th>
                <th>Payee</th>
                <th>Amount</th>
                <th>Destination</th>
              </thead>
              <tbody>
                <tr *ngFor="let outgoingCheck of body_link.outgoing_checks">
                  <td>
                    <a target="_blank" [href]="'/checks/' + outgoingCheck.check_id">{{ outgoingCheck.check_number }}</a>
                  </td>
                  <td>
                    <a target="_blank" [href]="'/contact/' + outgoingCheck.contact_id">{{ outgoingCheck.contact_name }}</a>
                  </td>
                  <td>{{ outgoingCheck.check_amount }}</td>
                  <td>
                    <a target="_blank" [href]="'/outgoing_jobs/' + body_link.link_id + '/outgoing_checks/' + outgoingCheck.id">
                      {{ outgoingCheck.destination }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card" *ngIf="matterHistory.replying">
          <div class="card-body">
            <app-matter-history-form [matter_id]="this.matter_id" [parent_id]="matterHistory.id" (formResult)="replyFormResult(matterHistory, $event)"></app-matter-history-form>
          </div>
        </div>
        <app-matter-histories
          #matterHistoryChildren
          [loadReplies]="matterHistory.loadReplies"
          [expandingAllLevels]="matterHistory.expandingAllLevels"
          [expandingChildren]="matterHistory.expandingChildren"
          *ngIf="matterHistory.reply_count > 0"
          (historyCount)="matterHistory.reply_count = $event; matterHistory.replyCountStr = replyCount($event)"
          [expandingAllLevels]="expandingAllLevels"
          [parent_id]="matterHistory.id"
          [matter_id]="matter_id"
        ></app-matter-histories>
      </div>
    </div>
  </div>
</div>
